import { useMemo } from "react"
import { useScaleApplication } from "@/domains/application/use-scale-application"
import { LcAddress } from "@/domains/core"

export const useClFarm = (clFarmAddress: string | undefined) => {
  const scaleApp = useScaleApplication()
  const clFarm = useMemo(() => {
    if (!clFarmAddress) {
      return null
    }
    const found = scaleApp.ClFarms.Repository.find(new LcAddress(clFarmAddress))
    return found ?? undefined
  }, [clFarmAddress, scaleApp.ClFarms.Repository.totalFarms])

  return clFarm
}
